function sortableTableController() {
	let isSortedTable = false;

	const sorttable = {
		init() {
			if (isSortedTable) return;
			isSortedTable = true;

			$('.js-sortable-table').each((_, table) => {
				sorttable.makeSortable(table);
			});
		},

		sortColumn(table, col) {
			const rows = Array.from(table.tBodies[0].rows);
			const headCell = table.tHead.rows[0].cells[col];
			const sortType = $(headCell).data('sortable-type') || sorttable.guessType(table, col);
			const rowArray = rows.map(row => [$(row.cells[col]), row]);

			rowArray.sort(sorttable[sortType]);

			rowArray.forEach(([, row]) => {
				table.tBodies[0].appendChild(row);
			});
		},

		makeSortable(table) {
			const sortbottomrows = [];

			// Move sortbottom rows to tfoot
			Array.from(table.rows).forEach(row => {
				if ($(row).hasClass('sortbottom')) {
					sortbottomrows.push(row);
				}
			});

			if (sortbottomrows.length > 0) {
				let tfoot = table.tFoot || table.createTFoot();
				sortbottomrows.forEach(row => tfoot.appendChild(row));
			}

			// Assign sorting types
			Array.from(table.tHead.rows[0].cells).forEach((cell, i) => {
				if (!cell.className.includes('sorttable_nosort')) {
					cell.sorttable_sortfunction = sorttable.guessType(table, i);
				}
			});

			$(table).find('.js-sortable-table-sorter').on('click', function (e) {
				if (e.target !== this) {
					this.click();
					return;
				}

				const colNum = $(this).data('sortable-table-col') - 1;
				const $target = $(e.target);

				const toggleReverse = () => {
					Object.values(table.tBodies).forEach(tbody => sorttable.reverse(tbody));
				};

				if ($target.hasClass('sorttable_sorted')) {
					sorttable.sortColumn(table, colNum);
					toggleReverse();
					$target.removeClass('sorttable_sorted').addClass('sorttable_sorted_reverse');
					return;
				}

				if ($target.hasClass('sorttable_sorted_reverse')) {
					toggleReverse();
					sorttable.sortColumn(table, colNum);
					$target.removeClass('sorttable_sorted_reverse').addClass('sorttable_sorted');
					return;
				}

				forEach(e.target.parentNode.childNodes, cell => {
					if (cell.nodeType === 1) {
						$(cell).removeClass('sorttable_sorted sorttable_sorted_reverse');
					}
				});

				$('.sorttable_sortfwdind, .sorttable_sortrevind').remove();

				$target.addClass('sorttable_sorted');
				sorttable.sortColumn(table, colNum);
			});
		},

		guessType(table, column) {
			for (const row of table.tBodies[0].rows) {
				const text = $(row.cells[column]).text().trim();
				if (text) {
					if (/^-?[£$¤]?[\d,.]+%?$/.test(text)) return 'sort_numeric';
					if (Date.parse(text)) return 'sort_by_date';
					return 'sort_alpha';
				}
			}
			return 'sort_alpha';
		},

		reverse(tbody) {
			const rows = Array.from(tbody.rows);
			for (let i = rows.length - 1; i >= 0; i--) {
				tbody.appendChild(rows[i]);
			}
		},

		sort_numeric(a, b) {
			const parse = val => parseFloat(val[0].text().replace(/[^0-9.-]/g, '')) || 0;
			return parse(a) - parse(b);
		},

		sort_alpha(a, b) {
			const aText = a[0].text().trim().toUpperCase();
			const bText = b[0].text().trim().toUpperCase();
			return aText.localeCompare(bText);
		},

		sort_by_date(a, b) {
			return new Date(b[0].text().trim()) - new Date(a[0].text().trim());
		},

		sort_checkbox(a, b) {
			const aChecked = a[0].find('input[type=checkbox]').prop('checked');
			const bChecked = b[0].find('input[type=checkbox]').prop('checked');
			return (aChecked === bChecked) ? 0 : (aChecked ? 1 : -1);
		},

		shaker_sort(list, compFunc) {
			let b = 0, t = list.length - 1, swap = true;
			while (swap) {
				swap = false;
				for (let i = b; i < t; ++i) {
					if (compFunc(list[i], list[i + 1]) > 0) {
						[list[i], list[i + 1]] = [list[i + 1], list[i]];
						swap = true;
					}
				}
				t--;
				if (!swap) break;
				for (let j = t; j > b; --j) {
					if (compFunc(list[j], list[j - 1]) < 0) {
						[list[j], list[j - 1]] = [list[j - 1], list[j]];
						swap = true;
					}
				}
				b++;
			}
		}
	};

	// forEach implementation
	const forEach = (object, block, context) => {
		if (!object) return;

		if (typeof object.forEach === 'function') {
			object.forEach(block, context);
		} else if (typeof object.length === 'number') {
			Array.prototype.forEach.call(object, block, context);
		} else {
			for (const key in object) {
				if (Object.prototype.hasOwnProperty.call(object, key)) {
					block.call(context, object[key], key, object);
				}
			}
		}
	};

	sorttable.init();
}

export default sortableTableController;
